export default "__VITE_ASSET__VodsOf0D__"